import styles from './LoginPage.module.css';
import BrandPanel from '../components/login/BrandPanel';
import ForgotPasswordForm from '../components/login/ForgotPasswordForm';

const ForgotPasswordPage = () => {
  return (
    <div className={styles.page}>
      {/* Left Column */}
      <div className={styles.leftCol}>
        <BrandPanel />
      </div>

      {/* Right Column */}
      <div className={styles.rightCol}>
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
